import '../static/dashboard.scss';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../static/popup.scss';
import { Navigate } from 'react-router-dom';
import '../static/newresume.css';
import '../static/gridlistbutton.scss';
import '../static/chatroom.css';
import '../static/customers-modern.css';

// A functional component for rendering a single button


const Customers = () => {
   const [formData, setFormData] = useState({ name: '', phone: '' });
  const [suggestions, setSuggestions] = useState([]);
  const [owners, setOwners] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [ownerData, setOwnerData] = useState(null);
  const [petData, setPetData] = useState(null);
  const [MessagePet, setMessagePet] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [groomingData, setGroomingData] = useState([]);
const [messageData, setMessageData] = useState([]);
const [petWalkingData, setPetWalkingData] = useState([]);
const [dayCareData, setDayCareData] = useState([]);
const [appointmentData, setAppointmentData] = useState([]);
const [teethData, setTeethData] = useState([]);
const [teethUltrasoundData, setTeethUltrasoundData] = useState([]);
const [responseMessage ,setResponseMessage] = useState('');

const [quickCustomerText, setQuickCustomerText] = useState('');
const [quickImportLoading, setQuickImportLoading] = useState(false);
const [quickImportResult, setQuickImportResult] = useState(null);
const [quickImportError, setQuickImportError] = useState('');

 const navigate = useNavigate(); // React Router hook for navigation
 const groomingRef = useRef(null);
  const daycareRef = useRef(null);
  const personalRef = useRef(null);
  const ultrasoundRef = useRef(null);
  const appointmentRef = useRef(null);
  const petwalkingRef = useRef(null);
    
  
  

const handleQuickCustomerImport = async () => {
  if (!quickCustomerText.trim()) {
    setQuickImportError("Please paste customer information first.");
    return;
  }

  setQuickImportLoading(true);
  setQuickImportError("");
  setQuickImportResult(null);

  try {
    const storedTokens = localStorage.getItem("authTokens");

    if (!storedTokens) {
      throw new Error("You are not logged in. Please login again.");
    }

    const tokens = JSON.parse(storedTokens);

    const accessToken =
      tokens.access ||
      tokens.access_token ||
      tokens.token;

    if (!accessToken) {
      throw new Error("Access token not found. Please login again.");
    }

    const form = new FormData();
    form.append("customer_text", quickCustomerText);

    const response = await axios.post(
      "/petgrooming/quick-customer-import/",
      form,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    setQuickImportResult(response.data);

    if (response.data?.owner) {
      setFormData({
        name: response.data.owner.name || "",
        phone: response.data.owner.phone || "",
      });
    }

  } catch (error) {
    console.error("Quick Customer Import Error:", error);

    setQuickImportError(
      error.response?.data?.error ||
      error.response?.data?.detail ||
      error.message ||
      "Could not save customer."
    );
  } finally {
    setQuickImportLoading(false);
  }
};


const taskLabels = {
  1: "Wash And Go",
  2: "Full Grooming",
  3: "Nail",
  4: "Teeth",
  5: "Others",
};

const statusLabels = {
  1: "Wash And Go",
  2: "Full Grooming",
  3: "Nail",
};

const staffLabels = {
  1: "First Groomer",
  2: "Second",
  3: "Third",
};
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    borderRadius: "12px",
    overflow: "hidden",
  };

  const thTdStyle = {
    padding: "0.75rem 1rem",
    textAlign: "center",
    borderBottom: "1px solid #e1e4e8",
    fontSize: "1rem",
    color: "#34495e",
  };

  const thStyle = {
    ...thTdStyle,
    backgroundColor: "#4a69bd",
    color: "#fff",
    fontWeight: 600,
  };

  const noDataStyle = {
    textAlign: "center",
    padding: "1rem",
  };

 
 
  // Handle name input change
// Fetch autocomplete suggestions when the name input changes
const handleNameChange = async (e) => {
  const { value } = e.target;
  setFormData((prevState) => ({
    ...prevState,
    name: value,
  }));

  if (value.length > 2) {
    fetchSuggestions(value);
  } else {
    setSuggestions([]);
  }
};
  


const handleSuggestionClick = (suggestion) => {
  setSelectedOwner(suggestion);
  setFormData({
    name: suggestion.name,
    phone: suggestion.phone_mobile,
  });
  setSuggestions([]);
};



    // Handle change in other input fields (e.g., owner's name)

  // Function to fetch pet names for autocomplete
  const fetchSuggestions = async (query) => {
    try {
    const response = await fetch(`/autocomplete_owner_phone/?query=${query}`);
    const data = await response.json();
    setSuggestions(data.suggestions || []);
  } catch (error) {
    alert('Error fetching Telephone:', error);
    console.error('Error fetching Telephone:', error);
  }
  };

  // Submit handler if needed
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedOwner) {
    alert("Please select an owner from the list.");
    return;
  }

  try {
    const response = await axios.get(`/searchowner?owner_id=${selectedOwner.id}`);

    setOwnerData(response.data.owner);
    setGroomingData(response.data.grooming);
    setMessageData(response.data.messages);
    setPetWalkingData(response.data.pet_walking);
    setDayCareData(response.data.daycare);
    setAppointmentData(response.data.appointments);
    setTeethData(response.data.teeth);
    setTeethUltrasoundData(response.data.teeth_ultrasound);
    setPetData(response.data.pets || []);


  } catch (error) {
    console.error("Error fetching all owner-related data:", error);
  }
};




  const handleSubmitFormTwo = async (e) => {
        e.preventDefault();

        const { phone } = formData;

        try {
        const queryParams = new URLSearchParams({ phone }).toString();
      
        const response = await fetch(`/fetch-pet/?${queryParams}`);

          if (!response.ok) {
            setResponseMessage('Pet not found.');
            return;
          }

          const data = await response.json();

          // Safely build URL query string for navigation
          const query = new URLSearchParams({
            id: data.id || '',
            name: data.name || '',
            catdog: data.catdog || '',
            owner: data.owner || '',
            image: data.image || '',
            phone: data.phone || '',
            breed: data.breed || '',
            age: data.age?.toString() || '',
            behaviour: data.behaviour || '',
            allergies: data.allergies || '',
            vaccinated: data.vaccinated?.toString() || '',
            grooming_history: data.grooming_history || '',
            booking_date: data.booking_date || '',
            extra_info: data.extra_info || '',
            text: data.text || ''
          }).toString();

          navigate(`/historygroom/?${query}`);
          } catch (error) {
          console.error('Error fetching pet:', error);
          setResponseMessage('An error occurred. Please try again.');
          }
          };

  // Fetch detailed data from backend when selectedOwner changes
useEffect(() => {
  if (selectedOwner) {
    // 1. Fetch detailed owner data
    axios
      .get(`/searchowner?owner_id=${selectedOwner.id}`)
      .then((res) => {
        setOwnerData(res.data);           // full data including pets
        setTeethData(res.data.teeth);    // set teeth data from response
        setDayCareData(res.data.daycare); 
        setPetWalkingData(res.data.pet_walking); 
      })
      .catch((err) => console.error(err));

    // 2. Fetch messages for selected owner
    axios
      .get(`/messagesowner?owner_id=${selectedOwner.id}`)
      .then((res) => setMessagePet(res.data))
      .catch((err) => console.error(err));
  }
}, [selectedOwner]);

     

  const handleScroll = (target) => {
    const map = {
      grooming: groomingRef,
      daycare: daycareRef,
      petwalking: petwalkingRef,
      personal: personalRef,
      ultrasound: ultrasoundRef,
      appointment: appointmentRef,
    };
    map[target]?.current?.scrollIntoView({ behavior: "smooth" });
  };


  const handleSubmitFromThree = async (e) => {
        e.preventDefault();

        const { phone } = formData;

        try {
        const queryParams = new URLSearchParams({ phone }).toString();
      
        const response = await fetch(`/fetch-pet/?${queryParams}`);

          if (!response.ok) {
            setResponseMessage('Pet not found.');
            return;
          }

          const data = await response.json();

          // Safely build URL query string for navigation
          const query = new URLSearchParams({
            id: data.id || '',
            name: data.name || '',
            catdog: data.catdog || '',
            owner: data.owner || '',
            image: data.image || '',
            phone: data.phone || '',
            breed: data.breed || '',
            age: data.age?.toString() || '',
            behaviour: data.behaviour || '',
            allergies: data.allergies || '',
            vaccinated: data.vaccinated?.toString() || '',
            grooming_history: data.grooming_history || '',
            booking_date: data.booking_date || '',
            extra_info: data.extra_info || '',
            text: data.text || ''
          }).toString();

          navigate(`/historygroom/?${query}`);
          } catch (error) {
          console.error('Error fetching pet:', error);
          setResponseMessage('An error occurred. Please try again.');
          }
          };

const ownerProfile = ownerData?.owner || ownerData || {};

const petsList = Array.isArray(petData)
  ? petData
  : Array.isArray(ownerData?.pets)
  ? ownerData.pets
  : [];

const walkingList = Array.isArray(petWalkingData)
  ? petWalkingData
  : Array.isArray(ownerData?.pet_walking)
  ? ownerData.pet_walking
  : [];

const daycareList = Array.isArray(dayCareData)
  ? dayCareData
  : Array.isArray(ownerData?.daycare)
  ? ownerData.daycare
  : [];

const appointmentsList = Array.isArray(groomingData) ? groomingData : [];

const teethList = Array.isArray(teethData) ? teethData : [];

const openPetProfile = (pet) => {
  const query = new URLSearchParams({
    id: pet.id || "",
    name: pet.name || "",
    catdog: pet.catdog || "",
    owner: pet.owner || ownerProfile.id || "",
    image: pet.image || "",
    phone: pet.phone || ownerProfile.phone_mobile || "",
    breed: pet.breed || "",
    age: pet.age?.toString() || "",
    behaviour: pet.behaviour || "",
    allergies: pet.allergies || "",
    vaccinated: pet.vaccinated?.toString() || "",
    grooming_history: pet.grooming_history || "",
    booking_date: pet.booking_date || "",
    extra_info: pet.extra_info || "",
    text: pet.text || "",
  }).toString();

  navigate(`/historygroom/?${query}`);
};

 
  return (
    <>
      <link href='https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' rel='stylesheet' />
      

      <section id="content" className="customers-modern">
         

        <main style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
         {/* Left Column */}
  <div style={{
    width: '20%',
    padding: '1rem',
    overflowY: 'auto',
    backgroundColor: '#f4f4f4',
    position: 'sticky',
    top: 0,
    height: '100vh',
    flexShrink: 0
  }} >
    <div className="main-header">

<div data-quick-import="1" style={{
  background: "#fff",
  border: "2px solid #111",
  borderRadius: "14px",
  padding: "14px",
  marginBottom: "18px"
}}>
  <h3 style={{ marginBottom: "10px" }}>
    Quick Customer Import
  </h3>

  <textarea
    value={quickCustomerText}
    onChange={(e) => setQuickCustomerText(e.target.value)}
    rows={10}
    placeholder={`Luna
Kati
British Shorthair
Cat
447472145555
a@a.co
N12 6YI`}
    style={{
      width: "100%",
      minHeight: "180px",
      padding: "10px",
      boxSizing: "border-box"
    }}
  />

  <button
    type="button"
    onClick={handleQuickCustomerImport}
    disabled={quickImportLoading}
    className="square-button"
    style={{ width: "100%", marginTop: "10px" }}
  >
    {quickImportLoading ? "Saving..." : "Add Customer & Pet"}
  </button>

  {quickImportError && (
    <div style={{ color: "red", marginTop: "10px" }}>
      {quickImportError}
    </div>
  )}

  {quickImportResult?.ok && (
    <div style={{
      marginTop: "10px",
      padding: "10px",
      background: "#ecfdf5"
    }}>
      <div>Owner: {quickImportResult.owner?.name}</div>
      <div>Phone: {quickImportResult.owner?.phone}</div>

      {quickImportResult.pet && (
        <>
          <div>Pet: {quickImportResult.pet.name}</div>
          <div>
            {quickImportResult.pet.breed} - {quickImportResult.pet.catdog}
          </div>
        </>
      )}
    </div>
  )}
</div>

      
<form className="contact-form" onSubmit={handleSubmit}>
  <label>Phone of Pet Owner</label>
  <div className="input-block">
    <input
      type="text"
      name="name"
      value={formData.name}
      onChange={handleNameChange}
      className="form-control"
      autoComplete="off"
      placeholder="Type owner's name or phone..."
    />

    <input
      name="phone"
      value={formData.phone}
      className="form-control"
      readOnly
    />

    {suggestions.length > 0 && (
      <div className="autocomplete-suggestions">
        {suggestions.map((suggestion) => (
          <div className="input-block" key={suggestion.id}>
            <input
              type="text"
              className="form-control mt-1"
              value={`${suggestion.name} (${suggestion.phone_mobile})`}
              onClick={() => handleSuggestionClick(suggestion)}
              readOnly
            />
          </div>
        ))}
      </div>
    )}
  </div>

  <div className="mt-3">
    <button type="submit" className="square-button">
      Find Out
    </button>
  </div>
</form>

    </div>
{showDetails && selectedOwner && ownerData ? (
  <>
    <h3>{selectedOwner.name}'s Information</h3>
    <h5>Pet Walking</h5>
    <ul>
      {ownerData.petwalking?.map((entry, idx) => (
        <li key={idx}>{entry.pet} from {entry.days} at {entry.times}</li>
      ))}
    </ul>
    <h5>Day Care</h5>
    <ul>
      {ownerData.daycare?.map((entry, idx) => (
        <li key={idx}>{entry.pet} from {entry.fromday} to {entry.endday}</li>
      ))}
    </ul>
    <h5>Appointments</h5>
    <ul>
      {ownerData.appointments?.map((entry, idx) => (
        <li key={idx}>{entry.pet} on {entry.day}</li>
      ))}
    </ul>
    
  </>
) : (
  <p> </p>
)}
 
     
 <div className="containerleftnav">

      <ul>
          <li style={{backgroundColor: '#180e12ff'}}>
          <input type="radio"
            id="r-option"
              name="selector"
              onChange={() => handleScroll("personal")}
               />
          <label htmlFor="r-option">Personal</label>
         </li>
           <li style={{backgroundColor: '#180e12ff'}}>
          <input type="radio"
            id="e-option"
              name="selector"
              onChange={() => handleScroll("ultrasound")}
               />
          <label htmlFor="e-option">UltraSound Teeth</label>
         </li>
           <li style={{backgroundColor: '#180e12ff'}}>
          <input type="radio"
            id="w-option"
              name="selector"
              onChange={() => handleScroll("appointment")}
               />
          <label htmlFor="w-option">Appointment</label>
         </li>
           <li style={{backgroundColor: '#180e12ff'}}>
          <input type="radio"
            id="q-option"
              name="selector"
              onChange={() => handleScroll("petwalking")}
               />
          <label htmlFor="q-option">Pet Walking</label>
         </li>
           
        <li style={{backgroundColor: '#180e12ff'}}>
          <input type="radio"
            id="f-option"
              name="selector"
              onChange={() => handleScroll("grooming")}
               />
          <label htmlFor="f-option">Grooming</label>
         </li>

        <li  style={{backgroundColor: '#180e12ff'}}>
          <input type="radio" 
          id="s-option"
              name="selector"
              onChange={() => handleScroll("daycare")}
               />
          <label htmlFor="s-option">Day Care</label>
          
        </li>

        <li  style={{backgroundColor: '#180e12ff'}}>
          <input type="radio" 
            id="t-option"
              name="selector"
              onChange={() => handleScroll("petwalking")}
               ></input>
          <label htmlFor="t-option">Pet Walking</label>
           
        </li>
      </ul>
    </div>
    
  </div>
{/* Middle Column */}
{/* Middle Column */}
<div className="customers-center">
  {!ownerData && (
    <section className="customer-wide-card customer-empty-state">
      <div>
        <span className="customer-kicker">Customer profile</span>
        <h1>Select a customer</h1>
        <p>
          Search an owner from the left panel to view their pets, notes,
          appointments, grooming history and messages.
        </p>
      </div>
    </section>
  )}

  <section className="customer-wide-card" ref={personalRef}>
    <div className="customer-section-head">
      <div>
        <span className="customer-kicker">Personal details</span>
        <h2>{ownerProfile?.name || "Unknown customer"}</h2>
        <p>Owner profile, contact information and registered pets.</p>
      </div>
      <div className="customer-badge">
        {petsList.length} pet{petsList.length === 1 ? "" : "s"}
      </div>
    </div>

    <div className="owner-profile-layout">
      <div className="owner-profile-main">
        <div className="owner-avatar">
          {ownerProfile?.signature ? (
            <img src={ownerProfile.signature} alt={ownerProfile?.name || "Owner"} />
          ) : (
            <span>{ownerProfile?.name?.[0] || "?"}</span>
          )}
        </div>

        <div>
          <h3>{ownerProfile?.name || "No owner selected"}</h3>
          <div className="owner-contact-grid">
            <a href={`tel:${ownerProfile?.phone_mobile || ""}`}>
              📞 {ownerProfile?.phone_mobile || "No phone"}
            </a>
            <a href={`mailto:${ownerProfile?.email || ""}`}>
              📧 {ownerProfile?.email || "No email"}
            </a>
            <span>🏠 {ownerProfile?.address || "No address"}</span>
            <span>📍 {ownerProfile?.postcode || "No postcode"}</span>
          </div>
        </div>
      </div>

      <div className="owner-stat-grid">
        <div>
          <strong>{petsList.length}</strong>
          <span>Pets</span>
        </div>
        <div>
          <strong>{ownerProfile?.numberofvisit || 0}</strong>
          <span>Visits</span>
        </div>
        <div>
          <strong>{ownerProfile?.points || 0}</strong>
          <span>Points</span>
        </div>
      </div>
    </div>

    {ownerProfile?.note && (
      <div className="owner-note">
        <strong>Owner note</strong>
        <p>{ownerProfile.note}</p>
      </div>
    )}

    <div className="customer-subhead">
      <h3>Pets</h3>
      <span>{petsList.length ? "Registered pets" : "No pets found"}</span>
    </div>

    <div className="pet-card-grid">
      {petsList.length > 0 ? (
        petsList.map((pet, index) => (
          <article key={pet.id || index} className="modern-pet-card">
            <div className="pet-avatar">
              {pet.image ? (
                <img src={pet.image} alt={pet.name || "Pet"} />
              ) : (
                <span>{pet.name?.[0] || "?"}</span>
              )}
            </div>

            <div>
              <h4>{pet.name || "Unknown pet"}</h4>
              <p>{pet.breed || "Unknown breed"}</p>
              <p>{pet.catdog || "Pet"}</p>
            </div>

            <button type="button" onClick={() => openPetProfile(pet)}>
              View profile
            </button>
          </article>
        ))
      ) : (
        <div className="customer-mini-empty">No pet data loaded yet.</div>
      )}
    </div>
  </section>

  <section className="customer-wide-card" ref={appointmentRef}>
    <div className="customer-section-head">
      <div>
        <span className="customer-kicker">Appointments</span>
        <h2>Upcoming appointments</h2>
        <p>All scheduled grooming appointments for this owner.</p>
      </div>
      <div className="customer-badge">
        {appointmentsList.length} record{appointmentsList.length === 1 ? "" : "s"}
      </div>
    </div>

    <div className="modern-table-wrap">
      <table className="modern-customer-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Day</th>
            <th>Staff</th>
            <th>Hour</th>
          </tr>
        </thead>
        <tbody>
          {appointmentsList.length > 0 ? (
            appointmentsList.map((grData, index) => (
              <tr key={index}>
                <td>{grData.datee || "—"}</td>
                <td>{grData.week || "—"}</td>
                <td>{staffLabels[grData.staff] || "—"}</td>
                <td>{grData.hour || "—"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No upcoming appointments.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </section>

  <section className="customer-wide-card" ref={ultrasoundRef}>
    <div className="customer-section-head">
      <div>
        <span className="customer-kicker">Dental care</span>
        <h2>Teeth records</h2>
        <p>Brushing, descaling and ultrasound teeth sessions.</p>
      </div>
      <div className="customer-badge">
        {teethList.length} record{teethList.length === 1 ? "" : "s"}
      </div>
    </div>

    <div className="record-grid">
      {teethList.length > 0 ? (
        teethList.map((entry, idx) => (
          <article key={idx} className="record-card">
            <div>
              <span>Type</span>
              <strong>
                {entry.type === 1
                  ? "Brushing"
                  : entry.type === 2
                  ? "Descaling"
                  : entry.type === 3
                  ? "Ultrasound"
                  : "Unknown"}
              </strong>
            </div>
            <p><b>Pet ID:</b> {entry.pet || "—"}</p>
            <p><b>Session:</b> {entry.session || "—"}</p>
            <p><b>Date:</b> {entry.day || "—"}</p>
            <p><b>Hour:</b> {entry.hour || "—"}</p>
            <p><b>Next:</b> {entry.nextsession || "—"} {entry.nextsessionhour || ""}</p>
            <p><b>Status:</b> {entry.done === 1 ? "Done" : "Pending"}</p>
            {entry.note && <p><b>Note:</b> {entry.note}</p>}
          </article>
        ))
      ) : (
        <div className="customer-mini-empty">No teeth records available.</div>
      )}
    </div>
  </section>

  <section className="customer-wide-card" ref={groomingRef}>
    <div className="customer-section-head">
      <div>
        <span className="customer-kicker">Grooming</span>
        <h2>Grooming history</h2>
        <p>Previous and upcoming grooming records.</p>
      </div>
      <div className="customer-badge">
        {appointmentsList.length} record{appointmentsList.length === 1 ? "" : "s"}
      </div>
    </div>

    <div className="record-grid">
      {appointmentsList.length > 0 ? (
        appointmentsList.map((grData, index) => (
          <article key={index} className="record-card">
            <div>
              <span>Date</span>
              <strong>{grData.datee || "—"}</strong>
            </div>
            <p><b>Day:</b> {grData.week || "—"}</p>
            <p><b>Staff:</b> {staffLabels[grData.staff] || "—"}</p>
            <p><b>Hour:</b> {grData.hour || "—"}</p>
          </article>
        ))
      ) : (
        <div className="customer-mini-empty">No grooming records found.</div>
      )}
    </div>
  </section>

  <section className="customer-wide-card" ref={petwalkingRef}>
    <div className="customer-section-head">
      <div>
        <span className="customer-kicker">Pet walking</span>
        <h2>Pet walking records</h2>
        <p>Walking sessions and notes for this owner.</p>
      </div>
      <div className="customer-badge">
        {walkingList.length} record{walkingList.length === 1 ? "" : "s"}
      </div>
    </div>

    <div className="record-grid">
      {walkingList.length > 0 ? (
        walkingList.map((entry, idx) => (
          <article key={idx} className="record-card">
            <div>
              <span>Pet ID</span>
              <strong>{entry.pet || "—"}</strong>
            </div>
            <p><b>From:</b> {entry.days || "—"}</p>
            <p><b>To:</b> {entry.daye || "—"}</p>
            <p><b>Time:</b> {entry.times || "—"} – {entry.timee || "—"}</p>
            <p><b>Price:</b> £{entry.price || "0"}</p>
            <p><b>Done:</b> {entry.done ? "Yes" : "No"}</p>
            {entry.note && <p><b>Note:</b> {entry.note}</p>}
          </article>
        ))
      ) : (
        <div className="customer-mini-empty">No pet walking records found.</div>
      )}
    </div>
  </section>

  <section className="customer-wide-card" ref={daycareRef}>
    <div className="customer-section-head">
      <div>
        <span className="customer-kicker">Day care</span>
        <h2>Day care records</h2>
        <p>Day care bookings, times and payment details.</p>
      </div>
      <div className="customer-badge">
        {daycareList.length} record{daycareList.length === 1 ? "" : "s"}
      </div>
    </div>

    <div className="record-grid">
      {daycareList.length > 0 ? (
        daycareList.map((entry, idx) => (
          <article key={idx} className="record-card">
            <div>
              <span>Entry</span>
              <strong>#{idx + 1}</strong>
            </div>
            <p><b>Pet ID:</b> {entry.pet || "—"}</p>
            <p><b>Phone:</b> {entry.phone || "—"}</p>
            <p><b>From:</b> {entry.fromday || "—"}</p>
            <p><b>To:</b> {entry.endday || "—"}</p>
            <p><b>Drop-off:</b> {entry.times || "—"}</p>
            <p><b>Pick-up:</b> {entry.timee || "—"}</p>
            <p><b>Price:</b> £{entry.price || "0"}</p>
            <p><b>Status:</b> {entry.done === 1 ? "Done" : "Pending"}</p>
            {entry.note && <p><b>Note:</b> {entry.note}</p>}
          </article>
        ))
      ) : (
        <div className="customer-mini-empty">No day care records found.</div>
      )}
    </div>
  </section>
</div>   
           
 {/* Right Column */}
  <div style={{
    width: '20%',
    backgroundColor: '#f9f9f9',
    padding: '1rem',
    position: 'relative',
    top: 0,
    height: '100vh',
    overflowY: 'auto',
    flexShrink: 0
  }} >
    {/* You can add any content here for the right sidebar */}
    <h3>Last Messages:</h3>
    <ul className="todo-list">
  <section
  style={{
    
    fontFamily: 'Segoe UI, sans-serif',
    background: 'linear-gradient(to bottom right, #f0f4f8, #e6eef3)',
    minHeight: '100vh',
  }}
>
  <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#333' }}>Messages</h2>

  <div style={{ width: '100%', maxWidth: '900px' }}>
    {messageData.map((grData, index) => (
      <div
        key={index}
        style={{
          borderLeft: '4px solid #4CAF50',
          background: '#ffffff',
          padding: '1rem 1.5rem',
          marginBottom: '1.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
        }}
      >
        <div style={{ fontSize: '0.9rem', color: '#888', marginBottom: '0.5rem' }}>
          📅 {grData.datee || 'N/A'} – 🕒 {grData.time || 'N/A'}
        </div>

        <div
          style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            marginBottom: '0.5rem',
            color: '#2c3e50',
          }}
        >
          Subject: {grData.subject || 'N/A'}
        </div>

        <div style={{ fontSize: '1rem', lineHeight: '1.6', color: '#444' }}>
          <strong>Message:</strong> {grData.text || 'N/A'}
        </div>
      </div>
    ))}
  </div>
</section>
</ul>

  </div>
  
        </main>
      </section>
    </>
  );
};

 
export default Customers;

